module.exports = __webpack_public_path__ + "img/s3_bgDesc.50b1f1ee.png";